import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import lang from '@/lang'

import { TextInput, CountryInput } from '@/modules/base/components/inputs'
import { setCompanyData } from '@/redux/ducks/onboarding/main-v2'

const { inputs } = lang.onboardingV2.companyAddress

const AddressInputs = props => {
  const classes = useStyles()
  const { setInputsValid } = props

  const dispatch = useDispatch()

  const { companyData } = useSelector(state => state.onboarding.mainV2)

  const handleInputChange = name => value => dispatch(setCompanyData({ ...companyData, [name]: value }))

  const handleCountryChange = (option) => {
    const countryIso = option ? option.iso2 : ''
    dispatch(setCompanyData({ ...companyData, countryIso }))
  }

  useEffect(() => {
    const {
      street,
      zipCode,
      city,
    } = companyData
    setInputsValid(street || (zipCode && city))
  }, [companyData])

  return (
    <>
      <div className={classes.root}>
        <div className={classes.column}>
          <div className={classes.inputsRow}>
            <TextInput
              className={classes.textField}
              name="street"
              label={inputs.street}
              value={companyData.street}
              onChange={handleInputChange('street')}
            />
          </div>
        </div>
      </div>
      <div className={classes.root}>
        <div className={classes.column}>
          <div className={classes.inputsRow}>
            <TextInput
              className={classes.zip}
              name="zipCode"
              label={inputs.zipCode}
              value={companyData.zipCode}
              onChange={handleInputChange('zipCode')}
            />
            <TextInput
              className={classes.city}
              name="city"
              label={inputs.city}
              value={companyData.city}
              onChange={handleInputChange('city')}
            />
          </div>
        </div>
      </div>
      <div className={classes.root}>
        <div className={classes.column}>
          <div className={classes.inputsRow}>
            <CountryInput value={companyData.countryIso} onChange={handleCountryChange} includeCodeInLabel className={clsx(classes.countryInput)} />
          </div>
        </div>
      </div>
    </>
  )
}

AddressInputs.propTypes = {
  setInputsValid: PropTypes.func,
}

AddressInputs.defaultProps = {
  setInputsValid: () => {},
}

const useStyles = makeStyles(theme => ({
  root: () => ({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
  }),
  column: {
    width: '100%',
  },
  inputsRow: {
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '@media (min-width: 800px)': {
      flexDirection: 'row',
    },
  },
  textFieldCity: {
    width: 230,
  },
  countryInput: {
    width: '100%',
    zIndex: 50,
  },
  multiRow: {
    width: '100%',
    '& + $name': {
      marginTop: 20,
      '@media (min-width: 800px)': {
        marginTop: 0,
      },
    },
    '@media (min-width: 800px)': {
      width: 'calc(50% - 10px)',
    },
  },
  zip: {
    '@media (min-width: 800px)': {
      flexBasis: '25%',
      paddingRight: 20,
    },
  },
}))
export default AddressInputs
